import "bootstrap/dist/css/bootstrap.css";

import React from "react";
import { Row, Col, Container } from "reactstrap";

import "../icofont.min.css";

// Web theme color root css
import "../components/colors.css";

import "../Terms.css";
import Tdscontact from "../components/Tdscontact";
import Tdsfooter from "../components/Tdsfooter";
import Tdsheader from "../components/Tdsheader";

export default function Terms() {
  return (
    <div className={"terms"}>
      {/* Navbar  */}
      <Tdsheader active={"terms"} isHome={false} />

      <div className={"section"} id={"terms"}>
        <h1 className={"heading mt-5 mb-1 ml-3 ml-sm-5"}>Terms & Conditions</h1>

        <Container className={"mt-5"}>
          <Row className={"mt-2 ml-2 mr-2"}>
            <Col xs={12}>
              <h4>Article 1) Introduction</h4>
              <p className="text-justify">
                Whereas, the customer desires periodic auditing &amp;
                maintenance of certain hydraulic equipment as follows, and
                whereas Opal Hydraulic is willing to accept the above services
                in accordance with the terms and conditions set forth herein.
              </p>
              <p className="text-justify">
                Now, therefore, for good and valuable consideration, the receipt
                and sufficiency of which is hereby acknowledged, the parties
                hereto agree as follows:
              </p>

              <h4>Article 2) Scope of Services</h4>

              <p>2-1) Periodic auditing includes:</p>
              <p>
                A1) Estimating jack lifespan and consequently estimating the
                need to replace rubber parts
                <br />
                A2) Checking the appearance and condition of moving metal parts,
                joints, and levers
                <br />
                A3) Checking the quality and required volume of hydraulic oil
                <br />
                A4) Checking for possible oil leakage
                <br />
                A5) Checking performance without applying pressure
                <br />
                A6) Checking performance under pressure
                <br />
              </p>
              <p className="text-justify">
                <em>Note (1):</em> The under-pressure inspection is based on
                tonnage that meets the normal needs of users and is not based on
                the nominal jack capacity.
              </p>
              <p className="text-justify">
                <em>Note (2):</em> Although these tests do not include auxiliary
                fixtures, it is essential that users receive the necessary
                advice on how to correct them and on other precautions.
              </p>

              <p className="text-justify">
                2-2) The outcome of the inspection conducted on each hydraulic
                unit, referenced by its unique code, shall be provided to the
                customer based on the approved checklist.
              </p>

              <p className="text-justify">
                2-3) Should any unit be identified as defective, Opal Hydraulic
                shall, upon the customer’s request, coordinate the transfer,
                repair, and return of the unit in accordance with the costs
                specified in Article 3.
              </p>

              <p>2-4) Repair Details:</p>
              <p>
                2-4-1) In the event of major damage to internal components
                (which will be identified after dismantling the defective unit)
                or if replacement parts cannot be supplied, Opal will not be
                responsible for repairing the above equipment.
                <br />
                2-4-2) In such cases, Opal is required to return the
                non-repairable equipment free of charge.
                <br />
                2-4-3) After dismantling each of the items subject to this
                contract, if it turns out that there is a need to spend more
                than the given quote, continuation of repair is subject to the
                customer’s agreement with the new quote.
              </p>

              <h4>Article 3) Service Fees</h4>
              <p className="text-justify">
                For the initial two-year period after customer registration,
                Opal Hydraulic’s service charges will be determined and invoiced
                in accordance with the items listed below:
              </p>
              <p>
                A. $99 for support of up to five hydraulic units under 3 tons
                <br />
                B. $99 for each car lifter/hoist under 3 tons
                <br />
                C. 30% discount for fixing defective units according to the
                latest price lists
                <br />
              </p>
              <p className="text-justify">
                <em className={"text-danger"}>Note 1:</em> The service fees for
                4- and 5-ton hydraulic units shall be calculated with a 50%
                increase based on the above-mentioned rates, and the rate for
                units over five tons shall be subject to mutual agreement
                between the parties.
              </p>
              <p className="text-justify">
                <em className={"text-danger"}>Note 2:</em> An annual support fee
                of AUD $99 shall cover a minimum of one and up to five hydraulic
                units. For every additional group of up to five units (i.e.,
                units 6 to 10, 11 to 15, and so on), an additional $99 shall be
                payable by the customer.
              </p>
              <p className="text-justify">
                <em className={"text-danger"}>Note 3:</em> The repair discount
                applies only to labor charges.
              </p>
              <p className="text-justify">
                <em className={"text-danger"}>Note 4:</em> A 30% discount shall
                be applied based on the quoted repair cost for each item.
              </p>

              <h4>Article 4) Other Considerations</h4>
              <p>
                4-1) The inspection time, transfer of defective jacks, and their
                return shall be scheduled by Opal Hydraulic and communicated to
                the customer via SMS.
                <br />
                4-2) Opal’s agents are responsible for the collection and
                delivery of identified items tagged with Opal’s code.
                <br />
                4-3) The duration of the contract is indefinite and shall remain
                in effect until terminated or withdrawn by either party.
                <br />
                4-4) The parties have the right to terminate the present
                contract by notifying the other party one month in advance.
                <br />
                4-5) Following the expiration of two years from the date of
                execution of the initial agreement, an amended version
                incorporating any changes shall be delivered to the customer’s
                registered email address.
                <br />
                <p>
                  4-6) Warranty and Repair Terms:
                  <p className="text-justify">
                    <em className={"text-danger"}>Note:</em> The following terms
                    and conditions apply only to customers who request repair
                    services.
                    <p>
                      • Restored equipment has a three-month warranty. The
                      warranty will be offered only for workmanship. If previous
                      defects of the repaired item have not been repaired, Opal
                      Hydraulic agrees to re-repair the defective item free of
                      charge.
                      <br />
                      • Damages caused by improper use and operation of repaired
                      equipment will void the warranty.
                      <br />
                      • Users are required to use hydraulic equipment in a
                      principled manner. Accidents caused by incorrect use
                      contrary to manufacturer instructions and safety warnings
                      are solely the customer’s responsibility.
                      <br />
                      • If during the restoration process new defects are
                      discovered that affect the previous quote, a new quote
                      will be provided. Continuation of repair is subject to the
                      customer’s agreement. If not agreed, Opal Hydraulic will
                      return the equipment free of charge.
                      <br />
                      • Since repair time cannot be estimated beforehand, the
                      completion time will be announced by Opal Hydraulic
                      subsequently.
                    </p>
                  </p>
                </p>
              </p>
              <h4>Article 5) Acceptance</h4>
              <p className="text-justify">
                By checking the box and proceeding, the customer confirms that
                they have read, understood, and agreed to these Terms &amp;
                Conditions. These Terms &amp; Conditions shall remain valid and
                binding until updated or replaced by Opal Hydraulic.
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Contact Us Section Start  */}
      <div className="section contactus grapping" id="contact">
        <Tdscontact />
      </div>

      {/* Footer  Section Start */}
      <div className="">
        <Tdsfooter />
      </div>
    </div>
  );
}
